import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect } from 'react';
import { Typography } from '@mui/material';
import { bitCount } from '../utils/utils';
import { MaterialBoolControl } from 'console/shared/components/fields';
import { SettingContainer } from './settings-card/container';
import { SettingFullRow } from './settings-card/full-row';
export const FlagSelector = memo(function FlagSelector(props) {
    const { value, flag_label, flag_help_id, mask, onChange, ...rest } = props;
    useEffect(() => {
        if (bitCount(mask) > 1) {
            console.error('Передано неверное количество флагов', flag_label, mask);
        }
    }, [mask, flag_label]);
    const onChangeFlag = useCallback((checked) => {
        const new_value = (value & ~mask) | (checked ? mask : 0);
        onChange(new_value);
    }, [value, mask, onChange]);
    return (_jsx(MaterialBoolControl, { label: flag_label, value: (value & mask) !== 0, onChange: onChangeFlag, help_id: flag_help_id, ...rest }));
});
function FlagSelectorsImpl(props) {
    const { value, bits, onChange, label } = props;
    return (_jsxs(SettingContainer, { gap: 1, gridTemplateColumns: "repeat(auto-fill, minmax(230px, 1fr))", gridTemplateRows: 'auto', children: [label && (_jsx(SettingFullRow, { children: _jsx(Typography, { variant: "subtitle1", color: "textSecondary", children: label }) })), bits
                .filter(({ bit, show }) => bit != 0 && (show ?? true))
                .map(({ bit, label, help_id }) => (_jsx(FlagSelector, { value: value, mask: bit, onChange: onChange, flag_label: label, flag_help_id: help_id }, bit)))] }));
}
export const FlagSelectors = memo(FlagSelectorsImpl);
